import { render, staticRenderFns } from "./ModalForPrioritising.vue?vue&type=template&id=37f95ef4&"
import script from "./ModalForPrioritising.vue?vue&type=script&lang=js&"
export * from "./ModalForPrioritising.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports